import { LinkTextButton } from "@vega-core/components/Buttons/LinkTextButton";
import { HtmlContent } from "@vega-core/components/HtmlContent/HtmlContent";
import { m } from "@vega-core/paraglide/messages";
import { buildTimeFlags } from "@vega-core/utils/buildTimeFlags";

import { RoleTabs } from "../../../../../scenes/Settings/components/PermissionsHelpModal/pages/RoleTabs";
import { ModalRoutes } from "../constants";

export const RolesReferencePage = ({
  navigate,
}: {
  navigate: (path: string) => void;
}) => (
  <div className="flex flex-col gap-4 max-w-lg pb-6">
    <h2 className="body-extra-large-semibold">
      {m.userManagement_help_understandingRoles()}
    </h2>

    <div className="body-base-regular text-text/primary">
      <p>
        <HtmlContent
          content={m.userManagement_help_understandingRolesIntro()}
        />
      </p>

      <ul className="list-disc list-outside space-y-2 pl-6 text-text/primary py-4">
        <li>
          <HtmlContent content={m.userManagement_help_offeringPhase()} />
        </li>
        {buildTimeFlags.reporting_settings_investments ? (
          <li>
            <HtmlContent content={m.userManagement_help_investmentPhase()} />
          </li>
        ) : null}
      </ul>

      <p>
        {m.userManagement_help_rolesPermissionsTableIntro()}{" "}
        <LinkTextButton
          className="h-auto"
          onClick={() => navigate(ModalRoutes.Permissions)}
          text={m.userManagement_help_clickHere()}
        />
        . {m.userManagement_help_rolesSummary()}
      </p>
    </div>

    <RoleTabs />
  </div>
);
